import { TFunction } from 'i18next';
import { z } from 'zod';

export const getFleetSchema = (t: TFunction) =>
  z.object({
    fleet: z.string().nonempty(t('common.validation.fieldRequired')),
    description: z.string().nonempty(t('common.validation.fieldRequired')),
    fleetId: z.string().optional(),
  });
